import { createRouter, createWebHistory } from 'vue-router'
import AuthView from '@/views/AuthView.vue'
import { activateAuthGuard } from './auth.guard'
import MainView from '@/views/MainView.vue'
import GameView from '@/views/GameView.vue'
import TabPlay from '@/components/TabPlay.vue'
import TabFriends from '@/components/TabFriends.vue'
import TabMain from '@/components/TabMain.vue'
import TabEarn from '@/components/TabEarn.vue'
import TabWallet from '@/components/TabWallet.vue'
import { useUserStore } from '@/stores/user'
import { ElMessage } from 'element-plus'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      redirect: '/app/tap'
    },
    {
      path: '/app',
      name: 'main',
      component: MainView,
      children: [
        {
          path: 'play',
          component: TabPlay,
          name: 'play'
        },
        {
          path: 'friends',
          component: TabFriends,
          name: 'friends'
        },
        {
          path: 'tap',
          component: TabMain,
          name: 'tap'
        },
        {
          path: 'earn',
          component: TabEarn,
          name: 'earn'
        },
        {
          path: 'wallet',
          component: TabWallet,
          name: 'wallet'
        }
      ]
    },
    {
      path: '/game',
      name: 'game',
      component: GameView,
      beforeEnter: async () => {
        const userStore = useUserStore()
        await userStore.fetchUser()
        if (!userStore.user?.passes) {
          ElMessage.warning('No Play Passes left :(')
          return false
        }
      }
    },
    {
      path: '/auth',
      name: 'auth',
      component: AuthView
    }
  ]
})

activateAuthGuard(router)
export default router
